import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { PageEmpty } from 'components/PageEmpty';
import React from 'react';
import { RepeatableListIntro } from './RepeatableListIntro';
import { PageHeader } from 'components/PageHeader';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASEREPEATABLE],
  Screens.ASEREPEATABLE_INTRO
>;

export const RepeatableListIntroScreen: React.FC<Props> = ({ route }) => {
  const { groupId, parent } = route.params;
  return (
    <Page paddingTop={0} paddingBottom={0} header={<PageHeader />}>
      <PageEmpty style={{ flex: 1, justifyContent: 'center' }}>
        <RepeatableListIntro groupId={groupId} parent={parent} />
      </PageEmpty>
    </Page>
  );
};
